window.expense = {
	
	init: function (){
		alert("expense init");
	},
	
	loadOverview: function(expid, context, showButtons) {

		context		= context == undefined ? "overview" : context;
		showButtons		= showButtons == undefined ? true : showButtons;
		var buttonset	= [];
		if(context === "validation") {
			
			if(showButtons) {
			
				buttonset = [
					{
						text : Loc.g("Refuser"), 
						click : function(){
							$("#exp_step").val("refused");$("#fastexpenseform").submit();
						}
					},
					{
						text : Loc.g("Accepter"), 
						click : function(){
							
							$(".btnAccept span").text(Loc.g('Chargement') + ' ...');
							$(".btnAccept").css('pointer-events','none');
							
							$("#exp_step").val("accepted");
							$("#fastexpenseform").submit();
						}
					}
				];
			}
		}else if(context === 'edition') {
			if(showButtons) {
				buttonset = [
					{
						text : Loc.g("Enregistrer"), 
						click : function(){$("#fastexpenseform").submit();
						}
					}
				];
			}
		}


		buttonset.unshift({
			text : Loc.g("Fermer"), 
			click : function(){
				$(this).dialog("close");
			}
		});

		var options = {
			title		: Loc.g("Note de frais"),
			buttons		: buttonset, 
			callback	: function(){
				MyFacture.customForm("#fastexpenseform");
				fastExpense.prepareFastExpense(context);
			},
			width		: 1200,
			height		: "auto"
		};
		 
		var fileOpt = {action:"loadOverview", context: context, expid: expid};
		MyWindow.load("expenses_expense", fileOpt, options);
	},
	
	deleteIt: function(expid){
		
		var options = {
			type		: 'warning',
			resizable	: false,
			noclose		: true,
			title		: Loc.g("Supprimer une note de frais"),
			buttons		: [
				{
					text : Loc.g("Fermer"), 
					click : function(){
						$(this).dialog("close");
					}
				},
				{
					text : Loc.g("Supprimer"), 
					click : function(){
						MyFacture.post('expenses_expense', {expid: expid, action:'delete'}, function(data){
							Utils.reload();
						}, "json");
					}
				}
			]
		};

		MyWindow.alert(Loc.g("Êtes vous certain de vouloir supprimer cette note de frais"), options);
	},
	
	download : function(expid) {
		
		Utils.relocate("?_f=expenses_expense&action=download&expid="+expid, true);
	},
	
	unlinkPayment : function(payRelatedId){
		var options = {
			type		: 'warning',
			resizable	: false,
			noclose		: true,
			title		: Loc.g("Délier le paiement"),
			buttons		: [
				{
					text : Loc.g("Fermer"), 
					click : function(){
						$(this).dialog("close");
					}
				},
				{
					text : Loc.g("Délier"), 
					click : function(){
						MyFacture.post('expenses_expense', {payRelatedId: payRelatedId, action:'unlinkPayment'}, function(data){
							Utils.reload();
						}, "json");
					}
				}
			]
		};

		MyWindow.alert(Loc.g("Êtes vous certain de vouloir délier ce paiement ? Pour supprimer le règlement, rendez-vous dans la liste des règlements."), options);
	}
};
		

window.expenses = {
	
	init: function (){
	},
		
	prepareFilterForm: function(){
		
        var options = {
			success:function(data){
				expenses.processFilterForm(data);
			}, 
			dataType:"json"
		};
        MyForm.prepare("expensesFilterForm", "expenses_expenses&action=updateListing", options);
    },
	processFilterForm: function(data){
		Listing.refresh("expensesListing", data, data.expenses_metadatas);
	},
		

	
	acceptAllWaitings : function(){
		var options = {
			title	: Loc.g("Accepter des notes de frais en masse"),
			buttons	: [
				{
					text : Loc.g("Fermer"),
					click : function(){
						$(this).dialog("close");
					}
				}
			],
			width:1200,
			height: 515,
			callback	: function(){
				MyTabs.initVertical("fastexpenseform");
			}
		};
		MyWindow.load('expenses_expenses', {action:"batchValidationForm"}, options);
		
		
	},

	massAccept : function(rowSelection){
		var options = {
			title		: Loc.g("Accepter des notes de frais en masse"),
			buttons		: [
				{
					text : Loc.g("Fermer"), 
					click : function(){
						$(this).dialog("close");
					}
				}
			],
			width		:1200,
			height		: 515,
			callback	: function(){
				MyTabs.initVertical("fastexpenseform");
			}
		};
		MyWindow.load('expenses_expenses', {action:"batchValidationForm", expensesId : rowSelection}, options);
	},
	
	
	validExpensesForStaff : function(staffID){
		
		var formID = 'validExpensesForm'+staffID;
		var options = {
			data		: {
				action : 'batchValidationRecord'
			},
			dataType	: "json",
			success		: function(data){
				var formIsOk = MyForm.processJson(data, formID);
				
				if(formIsOk){
					Listing.update('expensesListing');
					
					$('#'+formID).find('input[type=button]').remove();
					$('#expense_'+staffID).removeClass('current').unbind('click').prepend('<i class="fa fa-check-circle fa-green" style="margin-right:5px;"></i>');
					$('#expense_'+staffID).closest('li').addClass('processed');
					
					if($('#expense_'+staffID).closest('li').next('li:not(.processed)').length == 0){
						$('#expensesList').find('li:not(.processed):eq(0)').find('a').trigger('click');
					}else{
						$('#expense_'+staffID).closest('li').next('li:not(.processed)').find('a').trigger('click');
					}
					
					if($('#expensesList').find('li:not(.processed)').length == 0){
						$('.tab-content').hide();
						$('.placeholder').show();
					}
                    MyWindow.close();
				}
		
			}
		};
		
		MyForm.prepare(formID, "expenses_expenses", options, true);
		$('#'+formID).submit();
	},
	
	removeLine : function(ownerid, expID){
		
		$('#validExpensesForm'+ownerid).find('.expensesSummary #exp_'+expID).slideUp('fast', function(){
			$('#exp_'+expID+'_lines').remove();

			$(this).remove();
			var $form = $('#validExpensesForm'+ownerid);
			
			if($form.find('.expensesSummary tbody tr').length == 0){
				$form.closest('div').remove();
				$('#expensesList #expense_'+ownerid).closest('li').remove();
				
				if($('#expensesList').find('li:not(.processed)').length == 0){
					$('.tab-content').hide();
					$('.placeholder').show();
				}else{
					$('#expensesList li:not(.processed) a:eq(0)').trigger('click');
				}
				
			}else{
				
				var totalExpenses = Big(0);
				jQuery.data(document.body, 'newTotal', Big(0));
				
				$form.find('.expensesSummary tbody tr.exp-summary').each(function(){
					
					var total		= Big(parseFloat($(this).find('.totalTTC').val(), 10));
					totalExpenses	= totalExpenses.plus(total);
					
				});

				var numformat = NumberFormat.loadFromInputs('numformat_');

				$form.find('#exp_'+ownerid+'_pay_amount').val(NumberFormat.formatToDisplay(totalExpenses.toString(), numformat));
			}
			
		});
	},
	
	showDetails : function(ownerid, expID){
		
		if($('#exp_'+expID+'_lines').is(':visible')){
			$('#exp_'+expID+'_lines').fadeOut(300);
		}else{
			$('.exp_details:visible').hide();
			$('#exp_'+expID+'_lines').fadeIn(300);
		}
	},
	
	massRefuse : function(rowSelection){
			
		var options = {
			title		: Loc.g("Refuser des notes de frais en masse"),
			buttons		: [
				{
					text : Loc.g("Annuler"), 
					click : function(){
						$(this).dialog("close");
					}
				},
				{
					text : Loc.g("Enregistrer"), 
					click : function(){
						$("#expensesFormGroup").submit();
					}
				}
			],
			width		: 880,
			height		: 430,
			callback	: function(){expenses.prepareGroupeRefuseExpForm();}
		};
		MyWindow.load('expenses_expenses', {action:"refuseFormGroup", expensesId : rowSelection}, options);
	},
	prepareGroupeRefuseExpForm : function(){
		
		var options = {
			success	: function(data){
				MyWindow.close();
				Utils.reload();
			}, 
			data : {
				action	: 'refuseGroup'
			},
			dataType :"json"
		};
		
		MyForm.prepare("expensesFormGroup", "expenses_expenses", options, true);
		MyFacture.customForm();
	},
	
	switchValidationStaff:function(indice) {
		
		// Prospect list
		$("#expensesList li.current").removeClass("current");
		$("#expensesList li#expense_"+indice).addClass("current");
		
		// Form
		// Delay => cause jquery is randomly a f***ing dumbass with callback method !
		$("#contentPan .panForm:not(#panForm_"+indice+")").fadeOut(300);	
		$("#contentPan #panForm_"+indice).delay(300).fadeIn(300, function() {
			MyFacture.customForm("#panForm_"+indice);
		});
	},
	
	markAsRecordable: function(expid) {
		
		MyFacture.post("expenses_expense", {expid:expid, action:"markAsRecordable"}, function(data){
			
			Listing.update("expensesListing");
		
		}, "json");
	}
	
};

window.fastExpense = {
	
	init: function (){
		fastExpense.prepareFastExpense("N");
		fastExpense.changeCurrency(1);
	},
	
	prepareFastExpense: function(validation) {
		
		var options = {
			dataType		: "json",
			beforeSend		: function() {},
			uploadProgress	: function(event, position, total, percentComplete) {},
			success			: function(data) {
				fastExpense.recordFastExpense(data, validation);
			},
		};
		
		$('#fastexpenseform').ajaxForm(options);

		MyFacture.customForm();
		
		$('#fastexpenseform').on('change', '.row_tax_main select, .rowHT, .row_tax2 select', function(){ 
			fastExpense.updateTotal($(this).closest('.fastExpenseForm-table-row'));
		});
		
		$('#fastexpenseform').on('change', '.rowTTC', function(e){
			
			var $expBlock	= $(this).closest('.expenseBlock');
			var line		= $(this).closest('.fastExpenseForm-table-row');
			
			if($expBlock.find('.doublevat').val() === 'Y'){
				e.preventDefault();
			}else if($expBlock.find('.taxesInc').val() === 'Y'){
				
				var numberFormat	= NumberFormat.loadFromInputs("numformat_");

				var amountTTC		= Big(NumberFormat.formatToFloat($(this).val(), numberFormat));
				var taxid			= line.find('.row_tax_main select option:selected').val();
				var taxlabel		= line.find('.row_tax_main select option:selected').html();
				var taxrate			= Big(NumberFormat.formatToFloat(line.find('.row_tax_main select option:selected').attr('rate'), numberFormat));
				
				var lineHT			= amountTTC.div(taxrate.div(100).plus(Big(1))).round(2);
				
				line.find('.rowHT').val(NumberFormat.formatToDisplay(lineHT.toString(), numberFormat));
			}else{
				var numberFormat	= NumberFormat.loadFromInputs("numformat_");

				var amountTTC		= Big(NumberFormat.formatToFloat($(this).val(), numberFormat));
				var taxrate			= Big(0);
				
				var lineHT			= amountTTC.div(taxrate.div(100).plus(Big(1))).round(2);
				
				line.find('.rowHT').val(NumberFormat.formatToDisplay(lineHT.toString(), numberFormat));
			}
			
			fastExpense.updateTotal($(this).closest('.fastExpenseForm-table-row'));
		});
		
		fastExpense.switchType($('#expenseBlock_1 .taxesInc'));
	},
	
	recordFastExpense: function(data, validation){

		$('.errors').html("");
		$('.errors').hide();

		var formIsOk = MyForm.processJson(data, "fastexpenseform");

		if(formIsOk){
			
			Utils.relocate("?_f=expenses_expenses");
			
		}else {

			$(".btnAccept span").text(Loc.g('Accepter'));
			$(".btnAccept").css('pointer-events','auto');
			
			if(data.form.status === "failed") {

				for(var f=0; f < data.form.fields.length; f++){
					var field = data.form.fields[f];

					var tmp_field = field.fieldId.split("_");

					if(tmp_field[1] === "file") {
						$('#errors_'+tmp_field[2]).html(field.msg);
						$('#errors_'+tmp_field[2]).show();
					}

				}
			}
		}
	},
	
	updateTotal : function(row){
        var numberFormat	= NumberFormat.loadFromInputs("numformat_");
		var totalHT			= Big(0);
		var totalTaxes		= Big(0);
		var totalTTC		= Big(0);
		var taxes			= [];
		
		var hasDoubleVat	= row.closest('.expenseBlock').find('.doublevat').val();
		var hasVat			= row.closest('.expenseBlock').find('.hasvat').val();
		var indice			= row.attr("indice");
		var $expBlock		= row.closest('.expenseBlock');
		
		$expBlock.find('.fastExpenseForm-table-row:visible').each(function(){
			
			var amountHT	= Big(NumberFormat.formatToFloat($(this).find('.rowHT').val(), numberFormat));
			
			totalHT			= totalHT.plus(amountHT);
			var lineTTC		= 0;
			
			
			if(hasVat == 'Y'){
				
				var taxid		= $(this).find('.row_tax_main select option:selected').val();
				var taxlabel	= $(this).find('.row_tax_main select option:selected').html();
				var taxrate		= Big(NumberFormat.formatToFloat($(this).find('.row_tax_main select option:selected').attr('rate'), numberFormat));
				
				if(taxes[taxid] === undefined){
					taxes[taxid] = {
						id				: taxid, 
						label			: taxlabel,
						rate			: Big(taxrate), 
						baseAmount		: new Big(0), 
						amount			: new Big(0)
					};
				}
				
				if($expBlock.find('.taxesInc').val() == 'N'){
					lineTTC = amountHT.plus(amountHT.times(taxes[taxid].rate).div(100).round(2));
				}else {
					lineTTC = Big(NumberFormat.formatToFloat($(this).find('.rowTTC').val(), numberFormat));
				}
				

				taxes[taxid].baseAmount = taxes[taxid].baseAmount.plus(amountHT);

				if(hasDoubleVat == 'Y'){
					var tax2id	 = $(this).find('.row_tax2 select option:selected').val();
					var tax2label = $(this).find('.row_tax2 select option:selected').html();
					var tax2rate	= Big(NumberFormat.formatToFloat($(this).find('.row_tax2 select option:selected').attr('rate'), numberFormat));

					if(taxes[tax2id] === undefined){
						taxes[tax2id] = {
							id			: tax2id, 
							label		: tax2label,
							rate		: Big(tax2rate), 
							baseAmount	: new Big(0), 
							amount		: new Big(0)
						};
					}

					taxes[tax2id].baseAmount = taxes[tax2id].baseAmount.plus(amountHT);
					lineTTC = lineTTC.plus(amountHT.times(taxes[tax2id].rate).div(100).round(2));
				}
			}
			
			if($expBlock.find('.taxesInc').val() === 'N'){
				$(this).find('.rowTTC').val(NumberFormat.formatToDisplay(lineTTC, numberFormat));
			}else {
				totalTTC	= totalTTC.plus(lineTTC.round(2));
				var lineHT	= lineTTC.div(taxes[taxid].rate.div(100).plus(Big(1))).round(2);
				
				$(this).find('.rowHT').val(NumberFormat.formatToDisplay(lineHT, numberFormat));
			}
		});

		if($expBlock.find('.taxesInc').val() === 'N'){
			for(var i in taxes){
				if (taxes[i].baseAmount !== undefined){
					taxes[i].amount = taxes[i].baseAmount.times(taxes[i].rate).div(100).round(2);

					totalTaxes = totalTaxes.plus(taxes[i].amount);
				}
			}
		totalTTC = totalHT.plus(totalTaxes);
		}
		
		$('#totalTTC_'+indice+" .value").data('raw', totalTTC);
		var totalTTC = NumberFormat.formatToDisplay(totalTTC, numberFormat);
		
		if(NumberFormat.currencyToLeft(numberFormat)) {
			totalTTC = numberFormat.currency + ' ' + totalTTC;
		}
		if(NumberFormat.currencyToRight(numberFormat)) {
			totalTTC = totalTTC + ' ' + numberFormat.currency;
		}
		
		$('#totalTTC_'+indice+" .value").html(totalTTC);
		
	},
	
	changeCurrency : function(indice){
		
		$('#numformat_currency').val($("#exp_currency_"+indice+" option:selected").attr('symbol'));

		var numberFormat		= NumberFormat.loadFromInputs("numformat_");
		var totalTTC			= $('#totalTTC_'+indice+" .value").data('raw');
		
		if(totalTTC === undefined) {
			totalTTC = 0;
		}
		
		var formattedTotalTTC	= NumberFormat.formatToDisplay(totalTTC, numberFormat);
		
		if(NumberFormat.currencyToLeft(numberFormat)) {
			formattedTotalTTC = numberFormat.currency + ' ' + formattedTotalTTC;
		}
		if(NumberFormat.currencyToRight(numberFormat)) {
			formattedTotalTTC = formattedTotalTTC + ' ' + numberFormat.currency;
		}
		
		$('#totalTTC_'+indice+" .value").html(formattedTotalTTC);
	},

	addRow: function(indice){

		var nbRows =  parseFloat($('#expenseBlock_'+indice+' .fastExpenseForm-rows .fast_nbrows-'+indice).val());
		$('#expenseBlock_'+indice+' .fastexpenseForm-rows .fast_nbrows-'+indice).val(nbRows+1);
		
		var datas = {
			action	: "addRow", 
			nbRows	: nbRows, 
			indice	: indice,
			context	: ($('form[name=fastexpenseform] input[name=expid]').val() != undefined ? 'update' : 'create')
		};
		
		MyFacture.post("expenses_expenses", datas, function(data){
			
			var hasDoubleVat	= $('#expenseBlock_'+indice).find('.doublevat').val();
			var hasVat			= $('#expenseBlock_'+indice).find('.hasvat').val();
			var $row			= $(data.expenses_fastExpenseRow);
			
			if(hasVat === 'N'){
				$row.find('.row_tax_main').hide();
				$row.find('.row_tax2').hide();
			}else{
				if(hasDoubleVat === 'N'){
					$row.find('.row_tax2').hide();
				}
			}
			
			var lastAccountingCode = $('#expenseBlock_'+indice+' .fastExpenseForm-rows tbody tr:last .accountingCode').val();
			$row.find('.accountingCode').val(lastAccountingCode);
			
			$row.appendTo('#expenseBlock_'+indice+' .fastExpenseForm-rows tbody');
			
			MyFacture.customForm('#expenseBlock_'+indice+' .fastExpenseForm-rows tbody .row_'+indice+'-'+nbRows);
			
			fastExpense.switchType($('#expenseBlock_'+indice+' .taxesInc'));
		}, "json");
	},
	
	addExpense: function() {
		
		var indice	=  parseFloat($('#indice').val());
		
		var datas	= {
			action	: "addExpense", 
			indice	: indice
		};
		
		MyFacture.post("expenses_expenses", datas, function(data){
			
			var block = data.expenses_fastExpenseTemplate;
			$('#fastexpensesList').append(block);
			
			var newIndice = indice+1;
			$('#indice').val(newIndice);
			
			MyFacture.customForm("#expenseBlock_"+newIndice);
			fastExpense.updateTotal($("#expenseBlock_"+newIndice));
			
			if($('#fastexpensesList .expenseBlock').length > 1) {
				$('.deleteExpenseButton').show();
			}
			fastExpense.changeCurrency(newIndice);
			
		}, "json");
	},
	
	deleteRow: function(me){
		
		me.closest('tr').hide();
		fastExpense.updateTotal(me.closest('tr'));
		me.closest('tr').remove();

	},
	
	uploadedFile: function(data, indice) {
		
		if(data.file_infos != undefined) {
			
			$('#errors_'+indice).hide();
			
			var fileId = data.file_infos.file_id;
			
			if($("#exp_file_"+indice).val() === "") {
				$("#exp_file_"+indice).val(fileId);
			}else {
				$("#exp_file_"+indice).val($("#exp_file_"+indice).val()+","+fileId);
			}
			
			$("#fileList_"+indice).append("<li class='fa fa-blue fa-file-pdf-o' id='file_" + fileId + "'><a href='"+data.public_path+"' target='_blank'>"+data.name+"</a><a href='javascript:;' onclick='fastExpense.deleteAttachment(" + indice + ", " + fileId + ", " + $('#expenseId').val() + ");'><i class='fa fa-trash'><xsl:comment/></i></a></li>");
		}
	},
	
	deleteAttachment: function(indice, fileId, expeId) {
		// remove li
		$('#file_'+fileId).remove();
		
		// remove linkedFile from #exp_file_...
		var files	= $('#exp_file_' + indice).val().split(',');
		files		= Utils.array_remove(files, [fileId + '']);
		
		$('#exp_file_' + indice).val(files.join());
		
		// and delete the new file
		MyFacture.post('expenses_expenses', {'action': 'fastExpenseDeleteAttachment', 'fileid': fileId});
	},
	
	remove: function(id) {
		$("#expenseBlock_"+id).remove();
		
		if($('#fastexpensesList .expenseBlock').length === 1) {
			$('.deleteExpenseButton').hide();
		}	
	},
	
	switchType : function(elem) {
		
		var $purBlock	= elem.closest('.expenseBlock');
		
		var coloneHT	= $purBlock.find(".rowHT");
		var coloneTTC	= $purBlock.find(".rowTTC");
		
		if(elem.val() == "Y") {
			coloneTTC.removeAttr("readonly")
					.css("background-color", "#FFF");
			
			coloneHT.attr("readonly", "readonly")
					.css("background-color", "#F8F8F8");
		}else {
			coloneHT.removeAttr("readonly")
					.css("background-color", "#FFF");
			
			coloneTTC.attr("readonly", "readonly")
					.css("background-color", "#F8F8F8");
		}
		
		fastExpense.updateTotal($(this));
	}
};


window.ExpensesPrefs = {
	
	initAccounting : function(){
		
		$("select.mutlipleSelect").multipleSelect({
			placeholder		: Loc.g("Choisissez des valeurs"),
			width			: 500,
			countSelected	: false,
			selectAll		: false,
			position		: 'bottom',
			selectAllText: Loc.g('Tout Sélectionner'),
			allSelected: Loc.g('Tous sélectionnés'),
		});
	}
	
};
	
	
window.expensesTools = {
	linkTo: function(doctype, docid) {
		var options = {
			dialogClass : "white",
			title	: Loc.g("Lier une note de frais"),
			buttons: [
				{
					text	: Loc.g("Annuler"), 
					click	: function () {
						$(this).dialog("close");
					}},
				{
					text	: Loc.g("Enregistrer"), 
					click	: function () {
						$("#expenseLinkCustom").submit();
					}
				}
			],
			callback	: function(){
				expensesTools.prepareCustomEntries();
			}
		};
		
		var fileOpt = {
			action	: "addcustomentries",
			doctype	: doctype,
			docid	: docid
		};
		
		MyWindow.load("expenses_link", fileOpt, options);
	},
	
	prepareCustomEntries: function(doctype, docid){
		
		var formId	= "expenseLinkCustom";
		var options = {
			success	: function(data) {
				expensesTools.recordCustomEntriesCallback(data);
			}, 
			dataType: "json",
			data : {
				action:'recordcustomentries'
			}
		};
		
		MyForm.prepare(formId, "expenses_link", options, true);
		MyFacture.initEvent("#" + formId);
		
	},
	
	recordCustomEntriesCallback: function(data){
		
		if(data.status === 'ok') {
			Utils.relocate(window.location.href.replace(/&tab=margins/g, '')+'&tab=margins');
		}
		
	},

};